import React from 'react';

const FilesUploadingProps = {
  listFiles: [
    {
      title: 'Documento de identidad',
      typeFile: 'DOC-IDENTIDAD',
      description: (
        <>
          <p>Agrega una foto o imagen de tu DNI, CE, Pasaporte por ambos lados.</p>
        </>
      ),
      id: '1',
      btnAttach: 'ADJUNTAR',
      btnDelete: 'ELIMINAR',
      docUrl:
        process.env.PUBLIC_URL + '/assets/documents.v2/documento_identidad.png',
    },
    {
      title: 'Denuncia policial',
      typeFile: 'DENUNCIA-POLICIAL',
      description: (
        <>
          <p>Agrega una foto o imagen de la copia de la denuncia policial.</p>
        </>
      ),
      id: '2',
      btnAttach: 'ADJUNTAR',
      btnDelete: 'ELIMINAR',
      docUrl:
        process.env.PUBLIC_URL + '/assets/documents.v2/denuncia_policial.png',
    },
    {
      title: 'Sustento del bloqueo',
      typeFile: 'COPIA-BLOQUEO',
      description: (
        <>
          <p>
            Agrega una foto o imagen de la constancia que te dieron al bloquear tu tarjeta.
          </p>
        </>
      ),
      id: '3',
      btnAttach: 'ADJUNTAR',
      btnDelete: 'ELIMINAR',
      docUrl:
        process.env.PUBLIC_URL + '/assets/documents.v2/sustento_de_bloqueo.png',
    },
    {
      title: 'Comprobante de consumos indebidos',
      typeFile: 'COMP-CONSUMO-INDEBIDO',
      description: (
        <>
          <p>
            Agrega una foto o imagen donde figuren los movimientos que no
            reconoces.
          </p>
        </>
      ),
      id: '4',
      btnAttach: 'ADJUNTAR',
      btnDelete: 'ELIMINAR',
      docUrl:
        process.env.PUBLIC_URL +
        '/assets/documents.v2/comprobante_consumos_indebidos.png',
    },
    {
      title: 'Movimientos bancarios reclamados',
      typeFile: 'COPIA-MOVBANCARIOS',
      description: (
        <>
          <p>
            Agrega una foto o imagen donde figuren los movimientos que no reconoces.
          </p>
        </>
      ),
      id: '5',
      btnAttach: 'ADJUNTAR',
      btnDelete: 'ELIMINAR',
      docUrl:
        process.env.PUBLIC_URL +
        '/assets/documents.v2/movimientos_no_reconocidos.png',
    },
    {
      title: 'Carta emitida por el banco BBVA',
      typeFile: 'CARTA DEL BANCO',
      description: (
        <>
          <p>Solo este documento puedes adjuntarlo después del registro de siniestro ingresando de nuevo al formulario digital.</p>
        </>
      ),
      id: '6',
      btnAttach: 'ADJUNTAR',
      btnDelete: 'ELIMINAR',
      docUrl:
        process.env.PUBLIC_URL +
        '/assets/documents.v2/carta_de_respuesta_BBVA.png',
    },
  ],
};

export default FilesUploadingProps;
